import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "qr-view" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 1,
  class: "inner-wrapper"
}

import landingPageConst from '@/constants';
    import useQrStore from '@/store/qr';
    import useStore from '@/store';
    import CreditCardForm from '@/components/common/CreditCardForm.vue';
    import PaymentMethods from '@/components/common/PaymentMethods/PaymentMethods.vue';
    import PaymentSection from '@/components/Qr/PaymentSection.vue';
    import MachineInfo from '@/components/Qr/MachineInfo.vue';
    import ProductsInfo from '@/components/Qr/ProductsInfo.vue';
    import ErroMessage from '@/components/common/ErrorMessage.vue';
    import SuccessOverlay from '@/components/common/SuccessOverlay.vue';
    import Row from '@/components/common/RowSection.vue';
    import { onMounted, ref, reactive, computed, inject } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import ApiClient from '@/utils/apiClient';
    import TransactionInfo from '@/models/landingPage';
    import { Steps } from '../../constants/landingPage';
    import { RsaEncrypt } from '@/utils/encryptionUtils';
    import {
        PaymentProcessingOptions,
        PaymentMethodTypes,
        PaymentMethodProviders,
        BasePayConfiguration,
    } from '@/typings/paymentMethods';
    import { mapToTransactionInfo } from '../../mappers/landingPage';
    import SecurityIcons from '../../components/Qr/SecurityIcons.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'QrView',
  setup(__props) {

    const $t = inject('$t');
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const qrStore = useQrStore();
    const isReady = ref(false);

    store.setLoading(true);

    const qrCode = route.params.tranId?.toString();

    ApiClient.LandingPage.visit(qrCode)
        .then((response) => {
            mapToTransactionInfo(response.data, transactionInfo);
            store.setLanguage(response.data);
            qrStore.setPaymentData(response.data);
            isReady.value = true;
            store.setLoading(false);
        })
        .catch((error) => {
            console.log(error);
            // errorHandler(err);
        });

    //methods
    const isStep = (step: number) => step == qrStore.step;

    function errorHandler(err: any) {
        console.log(err);
        console.log('errorHandler:' + JSON.stringify(err));
        apiErrors.isError = true;
        apiErrors.errCode = err?.details ?? 152;
        // setClientError(err);
    }
    function errBackClick() {
        if (isStep(Steps.apmPay)) {
            qrStore.setStep(Steps.start);
        }
    }
    function PayCC(card: any) {
        isPayProccess.value = true;
        var cc = {
            number: card.cardNumber,
            name: card.cardName,
            expire: card.cardExpire,
            cvv: card.cardCvv,
        };
        const payload =
            publicKeyFromPem.value === null ? '' : RsaEncrypt(publicKeyFromPem.value, cc);
        var json = {
            // atoken: this.atoken,
            QR: qrCode,
            Payload: payload, //, session: sessionLandingPage  };
        };
        ApiClient.LandingPage.creditCard(json)
            .then(() => {
                qrStore.setStep(Steps.paymentSuccess);
                setTimeout(() => {
                    router.push({
                        name: 'Rating',
                        query: { qr: qrCode },
                    });
                }, 3000);
            })
            .catch(function (ex) {
                isPayProccess.value = false;
                errorHandler(ex);
            });
    }
    const apiErrors = reactive({
        isError: false,
        errCode: -1,
        isClientErr: false,
    });
    const generateOnClickPaymentOptions = (
        paymentMethodName: PaymentMethodProviders,
        errorNumber: number,
        configuration: any
    ): PaymentProcessingOptions => {
        return {
            gateway: paymentMethodName,
            onLoaded: () => {
                qrStore.setStep(Steps.apmPay);
                return true;
            },
            onSuccess: async (token: string) => {
                var json = {
                    QR: qrCode,
                    Payload: token,
                };
                // TODO: for dLandingPage purposes only. remove in the future
                try {
                    var result = await ApiClient.LandingPage.apm(json, paymentMethodName);
                    qrStore.setStep(Steps.paymentSuccess);
                    setTimeout(() => {
                        router.push({
                            name: 'Rating',
                            query: { qr: qrCode },
                        });
                    }, 3000);
                    return result.data;
                } catch (error) {
                    errorHandler(error);
                }
                return null;
            },
            onFailure: (err: any) => {
                isPayProccess.value = false;
                errorHandler({
                    response: {
                        data: { details: errorNumber },
                    },
                    obj: err,
                });
            },
            configuration,
        };
    };
    const onClickCC: PaymentProcessingOptions = {
        onLoaded: () => {
            qrStore.setStep(Steps.creditCard);
            return true;
        },
        configuration: {},
    };

    const paymentMethods: {
        [key in PaymentMethodTypes]: (
            paymentMethodName: PaymentMethodProviders,
            errorNumber: number,
            configuration: any
        ) => PaymentProcessingOptions;
    } = {
        [PaymentMethodTypes.APPLE_PAYMENT_METHOD]: generateOnClickPaymentOptions,
        [PaymentMethodTypes.GOOGLE_PAYMENT_METHOD]: generateOnClickPaymentOptions,
        [PaymentMethodTypes.CREDIT_CARD_PAYMENT_METHOD]: () => onClickCC,
    };
    function instanceOfPayConfig(obj: any): obj is BasePayConfiguration {
        return 'providerName' in obj;
    }
    const paymentMethodOptions = computed(() => {
        const pms: { [key in PaymentMethodTypes]?: PaymentProcessingOptions } = {};
        if (!qrStore.paymentMethodInformation) return pms;

        const entries = Object.entries(qrStore.paymentMethodInformation);
        entries.forEach(([key, value]) => {
            const pm = key as PaymentMethodTypes;
            if (pm !== null && instanceOfPayConfig(value)) {
                pms[pm] = paymentMethods[pm](
                    value.providerName,
                    landingPageConst.errors.gPayGenError,
                    value as any
                );
            } else {
                console.log('Payment provider not known: ' + value);
            }
        });
        return pms;
    });

    //refs
    const isPayProccess = ref<boolean>(false);

    //reactive
    const transactionInfo = reactive<TransactionInfo>({
        machine: {
            machineId: null,
            machinePic: '',
            machinePicture: '',
            machineName: '',
            machineNumber: '',
            rating: 0.0,
            currencySign: '',
            distImage: '',
            machineTypeLutCkey: '',
            machineTypeLutImage: '',
            products: [
                {
                    price: 0.0,
                    name: '',
                    image: '',
                    selectionId: null,
                },
            ],
        },
        step: 0,
        countryCode: 'US',
        currencyCode: 'USD',
        totalPrice: 0.0,
        publicKeyFromPem: null,
        token: null,
    });

    //computed
    const publicKeyFromPem = computed(() => transactionInfo.publicKeyFromPem);

    //hooks
    onMounted(async () => {
        qrStore.setStep(Steps.start);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (apiErrors.isError)
      ? (_openBlock(), _createBlock(ErroMessage, {
          key: 0,
          "error-types": _unref(landingPageConst).errors,
          "is-error": true,
          "err-code": apiErrors.errCode,
          "is-client-err": apiErrors.isClientErr,
          onErrBackClick: errBackClick
        }, null, 8, ["error-types", "err-code", "is-client-err"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (isStep(_unref(Steps).paymentSuccess))
        ? (_openBlock(), _createBlock(SuccessOverlay, {
            key: 0,
            class: "success_pay_con",
            img: "//static.nayax.com/machine_Landing_page_asstes/success4.gif"
          }))
        : _createCommentVNode("", true),
      (transactionInfo.machine && transactionInfo.machine.machineId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (isStep(_unref(Steps).start))
              ? (_openBlock(), _createBlock(MachineInfo, {
                  key: 0,
                  machine: transactionInfo.machine
                }, null, 8, ["machine"]))
              : _createCommentVNode("", true),
            _createVNode(ProductsInfo, {
              machine: transactionInfo.machine
            }, null, 8, ["machine"]),
            (isReady.value && (isStep(_unref(Steps).start) || isStep(_unref(Steps).apmPay)))
              ? (_openBlock(), _createBlock(PaymentMethods, {
                  key: 1,
                  "payment-methods": _unref(paymentMethodOptions),
                  "transaction-info": transactionInfo
                }, null, 8, ["payment-methods", "transaction-info"]))
              : _createCommentVNode("", true),
            (isStep(_unref(Steps).creditCard))
              ? (_openBlock(), _createBlock(PaymentSection, {
                  key: 2,
                  onNextStep: _cache[0] || (_cache[0] = ($event: any) => (_unref(qrStore).setStep(_unref(Steps).start))),
                  text: _unref($t)('Card Details'),
                  disabled: isPayProccess.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(CreditCardForm, {
                      "is-pay-proccess": isPayProccess.value,
                      onCreditcardSubmit: PayCC,
                      ref: "card_component"
                    }, null, 8, ["is-pay-proccess"])
                  ]),
                  _: 1
                }, 8, ["text", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(Row, null, {
              default: _withCtx(() => [
                _createVNode(SecurityIcons)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !apiErrors.isError]
    ])
  ]))
}
}

})